import { render, staticRenderFns } from "./UpdateCases.vue?vue&type=template&id=21697744&scoped=true"
import script from "./UpdateCases.vue?vue&type=script&lang=js"
export * from "./UpdateCases.vue?vue&type=script&lang=js"
import style0 from "./UpdateCases.vue?vue&type=style&index=0&id=21697744&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21697744",
  null
  
)

export default component.exports